import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSensor = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7066 16.3971C19.0664 13.0373 19.0664 7.57018 15.7066 4.21038C15.4261 3.92987 14.9717 3.92987 14.6912 4.21038C14.4106 4.49089 14.4106 4.94532 14.6912 5.22583C17.4913 8.02601 17.4913 12.5815 14.6912 15.3817C14.4106 15.6622 14.4106 16.1166 14.6912 16.3971C14.9717 16.6776 15.4261 16.6776 15.7066 16.3971Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.53529 5.22583C4.8158 4.94532 4.8158 4.49089 4.53529 4.21038C4.25478 3.92987 3.80036 3.92987 3.51985 4.21038C0.16005 7.57018 0.16005 13.0373 3.51985 16.3971C3.80035 16.6776 4.25478 16.6776 4.53529 16.3971C4.8158 16.1166 4.8158 15.6622 4.53529 15.3817C1.73511 12.5815 1.73511 8.02601 4.53529 5.22583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6757 14.3654C15.9156 12.1255 15.9156 8.48101 13.6757 6.24114C13.3952 5.96063 12.9408 5.96063 12.6603 6.24114C12.3798 6.52165 12.3798 6.97608 12.6603 7.25659C14.3398 8.93684 14.3398 11.6697 12.6603 13.35C12.3798 13.6305 12.3798 14.0849 12.6603 14.3654C12.9408 14.6459 13.3952 14.6459 13.6757 14.3654Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5669 14.3654C6.8474 14.0849 6.8474 13.6305 6.5669 13.35C4.88735 11.6697 4.88735 8.93684 6.5669 7.25659C6.8474 6.97608 6.8474 6.52165 6.5669 6.24114C6.28639 5.96063 5.83196 5.96063 5.55145 6.24114C3.31158 8.48101 3.31158 12.1255 5.55145 14.3654C5.83195 14.6459 6.28638 14.6459 6.5669 14.3654Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.61323 13.1761C11.1974 13.1761 12.4856 11.8879 12.4856 10.3037C12.4856 8.71951 11.1974 7.43127 9.61323 7.43127C8.02905 7.43127 6.74081 8.71951 6.74081 10.3037C6.74081 11.8879 8.02905 13.1761 9.61323 13.1761ZM9.61323 8.86748C10.405 8.86748 11.0494 9.51195 11.0494 10.3037C11.0494 11.0954 10.405 11.7399 9.61323 11.7399C8.82149 11.7399 8.17702 11.0954 8.17702 10.3037C8.17702 9.51195 8.82149 8.86748 9.61323 8.86748Z",
			fill: "currentColor"
		})
	] })
});
export default SvgSensor;
